/**
 * =====================================================================
 * UNIVERSIDADES Y CARRERAS PARA EXANI-II (CENEVAL) — MÉXICO
 * =====================================================================
 * Estructura completa de universidades que aplican EXANI-II con sus carreras
 * y mapeo a módulos disciplinares específicos.
 * 
 * Basado en: Lista oficial de instituciones Ceneval + convocatorias 2024-2027
 * =====================================================================
 */

// ---------------------------------------------------------------------
// 1. LISTA OFICIAL DE UNIVERSIDADES QUE APLICAN EXANI-II
// ---------------------------------------------------------------------
export const UNIVERSIDADES_EXANI = [
  { id: 'UAA', nombre: 'Universidad Autónoma de Aguascalientes', abreviatura: 'UAA', estado: 'Aguascalientes' },
  { id: 'UABCS', nombre: 'Universidad Autónoma de Baja California Sur', abreviatura: 'UABCS', estado: 'Baja California Sur' },
  { id: 'UACAM', nombre: 'Universidad Autónoma de Campeche', abreviatura: 'UACAM', estado: 'Campeche' },
  { id: 'UNACAR', nombre: 'Universidad Autónoma del Carmen', abreviatura: 'UNACAR', estado: 'Campeche' },
  { id: 'UNACH', nombre: 'Universidad Autónoma de Chiapas', abreviatura: 'UNACH', estado: 'Chiapas' },
  { id: 'UACH', nombre: 'Universidad Autónoma de Chihuahua', abreviatura: 'UACH', estado: 'Chihuahua' },
  { id: 'UAEH', nombre: 'Universidad Autónoma del Estado de Hidalgo', abreviatura: 'UAEH', estado: 'Hidalgo' },
  { id: 'UAEMEX', nombre: 'Universidad Autónoma del Estado de México', abreviatura: 'UAEMEX', estado: 'Estado de México' },
  { id: 'UAGRO', nombre: 'Universidad Autónoma de Guerrero', abreviatura: 'UAGRO', estado: 'Guerrero' },
  { id: 'UAEM', nombre: 'Universidad Autónoma del Estado de Morelos', abreviatura: 'UAEM', estado: 'Morelos' },
  { id: 'UAN', nombre: 'Universidad Autónoma de Nayarit', abreviatura: 'UAN', estado: 'Nayarit' },
  { id: 'UANL', nombre: 'Universidad Autónoma de Nuevo León', abreviatura: 'UANL', estado: 'Nuevo León' },
  { id: 'UQROO', nombre: 'Universidad Autónoma de Quintana Roo', abreviatura: 'UQROO', estado: 'Quintana Roo' },
  { id: 'UASLP', nombre: 'Universidad Autónoma de San Luis Potosí', abreviatura: 'UASLP', estado: 'San Luis Potosí' },
  { id: 'UAS', nombre: 'Universidad Autónoma de Sinaloa', abreviatura: 'UAS', estado: 'Sinaloa' },
  { id: 'UAT', nombre: 'Universidad Autónoma de Tamaulipas', abreviatura: 'UAT', estado: 'Tamaulipas' },
  { id: 'UATX', nombre: 'Universidad Autónoma de Tlaxcala', abreviatura: 'UATX', estado: 'Tlaxcala' },
  { id: 'UADY', nombre: 'Universidad Autónoma de Yucatán', abreviatura: 'UADY', estado: 'Yucatán' },
  { id: 'UAZ', nombre: 'Universidad Autónoma de Zacatecas', abreviatura: 'UAZ', estado: 'Zacatecas' },
  { id: 'UCOL', nombre: 'Universidad de Colima', abreviatura: 'UCOL', estado: 'Colima' },
  { id: 'UJAT', nombre: 'Universidad Juárez Autónoma de Tabasco', abreviatura: 'UJAT', estado: 'Tabasco' },
  { id: 'UNINAV', nombre: 'Universidad Naval', abreviatura: 'UNINAV', estado: 'Ciudad de México', militar: true },
  { id: 'UP', nombre: 'Universidad Panamericana', abreviatura: 'UP', estado: 'Ciudad de México', privada: true },
  { id: 'UV', nombre: 'Universidad Veracruzana', abreviatura: 'UV', estado: 'Veracruz' },
  { id: 'OTRA', nombre: 'Otra Universidad / Institución', abreviatura: 'OTRA', estado: 'Otro', personalizada: true }
];

// ---------------------------------------------------------------------
// 2. MAPA DE MÓDULOS CENEVAL (del exaniConstants.js)
// ---------------------------------------------------------------------
export const MODULOS_CENEVAL = {
  // Módulos específicos (24 reactivos, excepto Premedicina 48)
  administracion: { id: 'administracion', nombre: 'Administración', reactivos: 24, area: 'Económico-Administrativas' },
  aritmetica: { id: 'aritmetica', nombre: 'Aritmética', reactivos: 24, area: 'Exactas' },
  biologia: { id: 'biologia', nombre: 'Biología', reactivos: 24, area: 'Ciencias de la Salud' },
  calculo: { id: 'calculo', nombre: 'Cálculo diferencial e integral', reactivos: 24, area: 'Ingenierías' },
  ciencias_salud: { id: 'ciencias_salud', nombre: 'Ciencias de la Salud', reactivos: 24, area: 'Ciencias de la Salud' },
  derecho: { id: 'derecho', nombre: 'Derecho', reactivos: 24, area: 'Humanidades' },
  economia: { id: 'economia', nombre: 'Economía', reactivos: 24, area: 'Económico-Administrativas' },
  filosofia: { id: 'filosofia', nombre: 'Filosofía', reactivos: 24, area: 'Humanidades' },
  fisica: { id: 'fisica', nombre: 'Física', reactivos: 24, area: 'Ingenierías' },
  historia: { id: 'historia', nombre: 'Historia', reactivos: 24, area: 'Humanidades' },
  literatura: { id: 'literatura', nombre: 'Literatura', reactivos: 24, area: 'Humanidades' },
  matematicas_financieras: { id: 'matematicas_financieras', nombre: 'Matemáticas financieras', reactivos: 24, area: 'Económico-Administrativas' },
  premedicina: { id: 'premedicina', nombre: 'Premedicina', reactivos: 48, area: 'Ciencias de la Salud', noCombinable: true },
  probabilidad_estadistica: { id: 'probabilidad_estadistica', nombre: 'Probabilidad y estadística', reactivos: 24, area: 'Exactas' },
  psicologia: { id: 'psicologia', nombre: 'Psicología', reactivos: 24, area: 'Ciencias de la Salud' },
  quimica: { id: 'quimica', nombre: 'Química', reactivos: 24, area: 'Ciencias de la Salud' },
  
  // Módulos generales (24 reactivos)
  ciencias_experimentales: { id: 'ciencias_experimentales', nombre: 'Ciencias experimentales', reactivos: 24, area: 'General', general: true },
  ciencias_sociales: { id: 'ciencias_sociales', nombre: 'Ciencias sociales', reactivos: 24, area: 'General', general: true }
};

// ---------------------------------------------------------------------
// 3. ÁREAS TRANSVERSALES (OBLIGATORIAS PARA TODAS LAS CARRERAS)
// ---------------------------------------------------------------------
export const AREAS_TRANSVERSALES = [
  { id: 'comprension_lectora', nombre: 'Comprensión Lectora', reactivos: 30, tipo: 'predictiva' },
  { id: 'redaccion_indirecta', nombre: 'Redacción Indirecta', reactivos: 30, tipo: 'predictiva' },
  { id: 'pensamiento_matematico', nombre: 'Pensamiento Matemático', reactivos: 30, tipo: 'predictiva' },
  { id: 'ingles_diagnostico', nombre: 'Inglés Diagnóstico (B1)', reactivos: 30, tipo: 'diagnostica' }
];

// ---------------------------------------------------------------------
// 4. CARRERAS POR UNIVERSIDAD CON MÓDULOS ASIGNADOS
// ---------------------------------------------------------------------
// Estructura: universidadId -> [ { carreraId, nombre, nivel, modulosRequeridos[], descripcion } ]
// NOTA: Para universidades genéricas, se usan asignaciones basadas en área del conocimiento
// Cada universidad puede tener criterios propios; estas son las asignaciones MÁS COMUNES

export const CARRERAS_POR_UNIVERSIDAD = {
  // UNIVERSIDAD NAVAL (UNINAV) - SEMAR
  UNINAV: [
    { id: 'medico-cirujano-naval', nombre: 'Médico Cirujano Naval', nivel: 'Profesional', categoria: 'Salud', modulosRequeridos: ['premedicina'], modulosSugeridos: ['premedicina'], descripcion: 'Formación médica naval integral (Sanidad Naval, CDMX). EXANI-II con Premedicina (48 reactivos).' },
    { id: 'enfermeria-naval', nombre: 'Licenciatura en Enfermería Naval', nivel: 'Profesional', categoria: 'Salud', modulosRequeridos: ['ciencias_salud', 'quimica'], modulosSugeridos: ['ciencias_salud', 'quimica'], descripcion: 'Atención y cuidado del personal naval (Sanidad Naval, CDMX). Módulos: Ciencias de la Salud + Química.' },
    { id: 'ing-sistemas-navales', nombre: 'Ingeniería en Sistemas Navales', nivel: 'Profesional', categoria: 'Ingenierías', modulosRequeridos: ['calculo', 'fisica'], modulosSugeridos: ['calculo', 'fisica'], descripcion: 'Cuerpo General (Heroica Escuela Naval Militar, Antón Lizardo, Ver.). Módulos: Cálculo + Física.' },
    { id: 'ing-aeronaval', nombre: 'Ingeniería Aeronaval', nivel: 'Profesional', categoria: 'Ingenierías', modulosRequeridos: ['calculo', 'fisica'], modulosSugeridos: ['calculo', 'fisica'], descripcion: 'Piloto Aviador Naval (Heroica Escuela Naval Militar, Antón Lizardo, Ver.). Módulos: Cálculo + Física.' },
    { id: 'ing-hidrografia', nombre: 'Ingeniería en Hidrografía', nivel: 'Profesional', categoria: 'Ingenierías', modulosRequeridos: ['calculo', 'fisica'], modulosSugeridos: ['calculo', 'fisica'], descripcion: 'Infantería de Marina (Heroica Escuela Naval Militar, Antón Lizardo, Ver.). Módulos: Cálculo + Física.' }
  ],

  // UNIVERSIDADES AUTÓNOMAS - Mapeo genérico por área del conocimiento
  // Estos son los módulos MÁS COMUNES; cada universidad puede variar
  
  // CIENCIAS DE LA SALUD
  MEDICINA: { modulos: ['premedicina'], nombreArea: 'Medicina / Cirujano', noCombinable: true },
  ENFERMERIA: { modulos: ['ciencias_salud', 'quimica'], nombreArea: 'Enfermería' },
  ODONTOLOGIA: { modulos: ['premedicina'], nombreArea: 'Odontología', noCombinable: true },
  NUTRICION: { modulos: ['ciencias_salud', 'quimica'], nombreArea: 'Nutrición' },
  PSICOLOGIA: { modulos: ['psicologia', 'biologia'], nombreArea: 'Psicología' },
  FARMACIA: { modulos: ['ciencias_salud', 'quimica'], nombreArea: 'Farmacia' },
  VETERINARIA: { modulos: ['ciencias_salud', 'biologia'], nombreArea: 'Medicina Veterinaria' },
  FISIOTERAPIA: { modulos: ['ciencias_salud', 'biologia'], nombreArea: 'Fisioterapia' },
  BIOMEDICA: { modulos: ['ciencias_salud', 'quimica'], nombreArea: 'Ingeniería Biomédica' },

  // INGENIERÍAS Y EXACTAS
  ING_CIVIL: { modulos: ['calculo', 'fisica'], nombreArea: 'Ingeniería Civil' },
  ING_MECANICA: { modulos: ['calculo', 'fisica'], nombreArea: 'Ingeniería Mecánica' },
  ING_ELECTRICA: { modulos: ['calculo', 'fisica'], nombreArea: 'Ingeniería Eléctrica' },
  ING_ELECTRONICA: { modulos: ['calculo', 'fisica'], nombreArea: 'Ingeniería Electrónica' },
  ING_SISTEMAS: { modulos: ['calculo', 'fisica'], nombreArea: 'Ingeniería en Sistemas / Computación' },
  ING_INDUSTRIAL: { modulos: ['calculo', 'probabilidad_estadistica'], nombreArea: 'Ingeniería Industrial' },
  ING_QUIMICA: { modulos: ['calculo', 'quimica'], nombreArea: 'Ingeniería Química' },
  ING_AMBIENTAL: { modulos: ['calculo', 'biologia'], nombreArea: 'Ingeniería Ambiental' },
  ARQUITECTURA: { modulos: ['calculo', 'fisica'], nombreArea: 'Arquitectura' },
  MATEMATICAS: { modulos: ['calculo', 'probabilidad_estadistica'], nombreArea: 'Matemáticas / Matemáticas Aplicadas' },
  FISICA: { modulos: ['calculo', 'fisica'], nombreArea: 'Física' },
  QUIMICA: { modulos: ['quimica', 'biologia'], nombreArea: 'Química' },

  // CIENCIAS SOCIALES, ECONÓMICO-ADMINISTRATIVAS Y HUMANIDADES
  ADMINISTRACION: { modulos: ['administracion', 'matematicas_financieras'], nombreArea: 'Administración / Negocios' },
  CONTADURIA: { modulos: ['administracion', 'matematicas_financieras'], nombreArea: 'Contaduría Pública' },
  ECONOMIA: { modulos: ['economia', 'matematicas_financieras'], nombreArea: 'Economía' },
  DERECHO: { modulos: ['derecho', 'historia'], nombreArea: 'Derecho' },
  COMUNICACION: { modulos: ['filosofia', 'literatura'], nombreArea: 'Comunicación / Periodismo' },
  SOCIOLOGIA: { modulos: ['ciencias_sociales', 'historia'], nombreArea: 'Sociología / Antropología' },
  TRABAJO_SOCIAL: { modulos: ['ciencias_sociales', 'psicologia'], nombreArea: 'Trabajo Social' },
  RELACIONES_INTERNACIONALES: { modulos: ['historia', 'derecho'], nombreArea: 'Relaciones Internacionales' },
  CIENCIAS_POLITICAS: { modulos: ['derecho', 'historia'], nombreArea: 'Ciencia Política' },
  PEDAGOGIA: { modulos: ['psicologia', 'filosofia'], nombreArea: 'Pedagogía / Educación' },
  HISTORIA: { modulos: ['historia', 'filosofia'], nombreArea: 'Historia' },
  FILOSOFIA: { modulos: ['filosofia', 'literatura'], nombreArea: 'Filosofía' },
  LITERATURA: { modulos: ['literatura', 'filosofia'], nombreArea: 'Literatura / Letras' },
  LENGUAS: { modulos: ['literatura', 'historia'], nombreArea: 'Lenguas / Traducción' },
  DISENO: { modulos: ['arte_disenio', 'historia'], nombreArea: 'Diseño Gráfico / Industrial' }, // arte_disenio no existe, usar general
  ARTES: { modulos: ['literatura', 'historia'], nombreArea: 'Artes Visuales / Plásticas' },

  // CIENCIAS EXPERIMENTALES (Generales)
  BIOLOGIA: { modulos: ['biologia', 'quimica'], nombreArea: 'Biología' },
  GEOLOGIA: { modulos: ['ciencias_experimentales', 'fisica'], nombreArea: 'Geología / Ciencias de la Tierra' },
  QUIIMICA_PURA: { modulos: ['quimica', 'fisica'], nombreArea: 'Química (Ciencias Básicas)' }
};

// ---------------------------------------------------------------------
// 5. MAPA DE CARRERAS COMUNES PARA UNIVERSIDADES GENÉRICAS
// ---------------------------------------------------------------------
// Cada universidad tiene sus propias carreras; esto es un catálogo base
export const CATALOGO_CARRERAS_GENERICO = [
  // Salud
  { id: 'medicina', nombre: 'Médico Cirujano / Medicina', categoria: 'Salud', modulosSugeridos: ['premedicina'], noCombinable: true },
  { id: 'enfermeria', nombre: 'Enfermería', categoria: 'Salud', modulosSugeridos: ['ciencias_salud', 'quimica'] },
  { id: 'odontologia', nombre: 'Odontología', categoria: 'Salud', modulosSugeridos: ['premedicina'], noCombinable: true },
  { id: 'nutricion', nombre: 'Nutrición', categoria: 'Salud', modulosSugeridos: ['ciencias_salud', 'quimica'] },
  { id: 'psicologia', nombre: 'Psicología', categoria: 'Salud', modulosSugeridos: ['psicologia', 'biologia'] },
  { id: 'farmacia', nombre: 'Farmacia / Químico Farmacéutico', categoria: 'Salud', modulosSugeridos: ['ciencias_salud', 'quimica'] },
  { id: 'veterinaria', nombre: 'Medicina Veterinaria', categoria: 'Salud', modulosSugeridos: ['ciencias_salud', 'biologia'] },
  { id: 'fisioterapia', nombre: 'Fisioterapia / Terapia Física', categoria: 'Salud', modulosSugeridos: ['ciencias_salud', 'biologia'] },
  { id: 'biomedica', nombre: 'Ingeniería Biomédica', categoria: 'Salud', modulosSugeridos: ['ciencias_salud', 'quimica'] },

  // Ingenierías
  { id: 'ing_civil', nombre: 'Ingeniería Civil', categoria: 'Ingenierías', modulosSugeridos: ['calculo', 'fisica'] },
  { id: 'ing_mecanica', nombre: 'Ingeniería Mecánica', categoria: 'Ingenierías', modulosSugeridos: ['calculo', 'fisica'] },
  { id: 'ing_electrica', nombre: 'Ingeniería Eléctrica', categoria: 'Ingenierías', modulosSugeridos: ['calculo', 'fisica'] },
  { id: 'ing_electronica', nombre: 'Ingeniería Electrónica', categoria: 'Ingenierías', modulosSugeridos: ['calculo', 'fisica'] },
  { id: 'ing_sistemas', nombre: 'Ingeniería en Sistemas / Computación', categoria: 'Ingenierías', modulosSugeridos: ['calculo', 'fisica'] },
  { id: 'ing_industrial', nombre: 'Ingeniería Industrial', categoria: 'Ingenierías', modulosSugeridos: ['calculo', 'probabilidad_estadistica'] },
  { id: 'ing_quimica', nombre: 'Ingeniería Química', categoria: 'Ingenierías', modulosSugeridos: ['calculo', 'quimica'] },
  { id: 'ing_ambiental', nombre: 'Ingeniería Ambiental', categoria: 'Ingenierías', modulosSugeridos: ['calculo', 'biologia'] },
  { id: 'arquitectura', nombre: 'Arquitectura', categoria: 'Ingenierías', modulosSugeridos: ['calculo', 'fisica'] },
  { id: 'matematicas', nombre: 'Matemáticas / Matemáticas Aplicadas', categoria: 'Exactas', modulosSugeridos: ['calculo', 'probabilidad_estadistica'] },
  { id: 'fisica', nombre: 'Física', categoria: 'Exactas', modulosSugeridos: ['calculo', 'fisica'] },
  { id: 'quimica_pura', nombre: 'Química', categoria: 'Exactas', modulosSugeridos: ['quimica', 'fisica'] },

  // Económico-Administrativas
  { id: 'administracion', nombre: 'Administración / Negocios', categoria: 'Económico-Administrativas', modulosSugeridos: ['administracion', 'matematicas_financieras'] },
  { id: 'contaduria', nombre: 'Contaduría Pública', categoria: 'Económico-Administrativas', modulosSugeridos: ['administracion', 'matematicas_financieras'] },
  { id: 'economia', nombre: 'Economía', categoria: 'Económico-Administrativas', modulosSugeridos: ['economia', 'matematicas_financieras'] },
  { id: 'marketing', nombre: 'Mercadotecnia / Marketing', categoria: 'Económico-Administrativas', modulosSugeridos: ['administracion', 'economia'] },
  { id: 'finanzas', nombre: 'Finanzas', categoria: 'Económico-Administrativas', modulosSugeridos: ['matematicas_financieras', 'economia'] },
  { id: 'comercio_internacional', nombre: 'Comercio Internacional', categoria: 'Económico-Administrativas', modulosSugeridos: ['administracion', 'economia'] },

  // Humanidades y Sociales
  { id: 'derecho', nombre: 'Derecho', categoria: 'Humanidades', modulosSugeridos: ['derecho', 'historia'] },
  { id: 'comunicacion', nombre: 'Comunicación / Periodismo', categoria: 'Humanidades', modulosSugeridos: ['filosofia', 'literatura'] },
  { id: 'sociologia', nombre: 'Sociología / Antropología', categoria: 'Humanidades', modulosSugeridos: ['ciencias_sociales', 'historia'] },
  { id: 'trabajo_social', nombre: 'Trabajo Social', categoria: 'Humanidades', modulosSugeridos: ['ciencias_sociales', 'psicologia'] },
  { id: 'relaciones_internacionales', nombre: 'Relaciones Internacionales', categoria: 'Humanidades', modulosSugeridos: ['historia', 'derecho'] },
  { id: 'politica', nombre: 'Ciencia Política', categoria: 'Humanidades', modulosSugeridos: ['derecho', 'historia'] },
  { id: 'pedagogia', nombre: 'Pedagogía / Educación', categoria: 'Humanidades', modulosSugeridos: ['psicologia', 'filosofia'] },
  { id: 'historia', nombre: 'Historia', categoria: 'Humanidades', modulosSugeridos: ['historia', 'filosofia'] },
  { id: 'filosofia', nombre: 'Filosofía', categoria: 'Humanidades', modulosSugeridos: ['filosofia', 'literatura'] },
  { id: 'literatura', nombre: 'Literatura / Letras', categoria: 'Humanidades', modulosSugeridos: ['literatura', 'filosofia'] },
  { id: 'lenguas', nombre: 'Lenguas / Traducción', categoria: 'Humanidades', modulosSugeridos: ['literatura', 'historia'] },
  { id: 'diseno', nombre: 'Diseño Gráfico / Industrial', categoria: 'Humanidades', modulosSugeridos: ['ciencias_sociales', 'historia'] },
  { id: 'artes', nombre: 'Artes Visuales / Plásticas', categoria: 'Humanidades', modulosSugeridos: ['literatura', 'historia'] },

  // Ciencias Experimentales
  { id: 'biologia', nombre: 'Biología', categoria: 'Ciencias Experimentales', modulosSugeridos: ['biologia', 'quimica'] },
  { id: 'geologia', nombre: 'Geología / Ciencias de la Tierra', categoria: 'Ciencias Experimentales', modulosSugeridos: ['ciencias_experimentales', 'fisica'] }
];

// ---------------------------------------------------------------------
// 6. FUNCIONES DE UTILIDAD
// ---------------------------------------------------------------------

/**
 * Obtiene los módulos requeridos para una carrera específica en una universidad
 */
export function getModulosParaCarrera(universidadId, carreraId) {
  // Caso especial UNINAV
  if (universidadId === 'UNINAV') {
    const carrera = CARRERAS_POR_UNIVERSIDAD.UNINAV.find(c => c.id === carreraId);
    return carrera?.modulosRequeridos || [];
  }

  // Buscar en catálogo genérico
  const carrera = CATALOGO_CARRERAS_GENERICO.find(c => c.id === carreraId);
  if (carrera) {
    return carrera.modulosSugeridos || [];
  }

  // Fallback: buscar en mapeo por área
  const areaMap = CARRERAS_POR_UNIVERSIDAD[carreraId.toUpperCase()];
  if (areaMap) {
    return areaMap.modulos || [];
  }

  return [];
}

/**
 * Obtiene todos los tema_ids correspondientes a una lista de módulos
 * Los módulos mapean a temas en el área 5 (Módulos Disciplinares)
 */
export const MODULO_A_TEMA_IDS = {
  // Áreas Transversales (1..10)
  pensamiento_matematico: [1, 2, 3],
  comprension_lectora: [4, 5, 6],
  redaccion_indirecta: [7, 8],
  ingles_diagnostico: [9, 10],
  ingles: [9, 10],

  // Módulos Específicos Ceneval (11..47)
  administracion: [11, 12],
  aritmetica: [13, 14],
  biologia: [15, 16],
  calculo: [17, 18],
  calculo_diferencial_e_integral: [17, 18],
  ciencias_salud: [19, 20],
  ciencias_de_la_salud: [19, 20],
  derecho: [21, 22],
  economia: [23, 24],
  filosofia: [25, 26],
  fisica: [27, 28],
  historia: [29, 30],
  literatura: [31, 32],
  matematicas_financieras: [33, 34],
  premedicina: [35, 36, 37],
  probabilidad_estadistica: [38, 39],
  probabilidad_y_estadistica: [38, 39],
  psicologia: [40, 41],
  quimica: [42, 43],
  ciencias_experimentales: [44, 45],
  ciencias_sociales: [46, 47]
};

/**
 * Obtiene los tema_ids permitidos para los módulos de una carrera
 * Incluye siempre las áreas transversales (subáreas 1 a 10) + las subáreas de módulos específicos
 */
export function getTemaIdsParaModulos(modulosRequeridos) {
  const temaIds = new Set();
  
  // Siempre incluir áreas transversales oficiales CENEVAL (subáreas 1 a 10 de áreas 1, 2, 3 y 4)
  for (let i = 1; i <= 10; i++) {
    temaIds.add(i);
  }
  
  // Agregar subáreas de módulos específicos requeridos por la carrera
  for (const modulo of (modulosRequeridos || [])) {
    const temasModulo = MODULO_A_TEMA_IDS[modulo] || [];
    temasModulo.forEach(id => temaIds.add(id));
  }
  
  return Array.from(temaIds);
}

/**
 * Obtiene el plan de estudios completo (transversales + específicos) para una carrera
 */
export function getPlanEstudiosCompleto(universidadId, carreraId) {
  const modulosEspecificos = getModulosParaCarrera(universidadId, carreraId);
  
  return {
    transversales: AREAS_TRANSVERSALES.map(a => ({ ...a, obligatorio: true })),
    especificos: modulosEspecificos.map(mId => {
      const modulo = MODULOS_CENEVAL[mId];
      return modulo ? { ...modulo, obligatorio: true } : { id: mId, nombre: mId, reactivos: 24, obligatorio: true };
    }),
    totalReactivos: 90 + modulosEspecificos.reduce((sum, mId) => {
      const m = MODULOS_CENEVAL[mId];
      return sum + (m?.reactivos || 24);
    }, 0),
    esPremedicina: modulosEspecificos.includes('premedicina'),
    temaIdsPermitidos: getTemaIdsParaModulos(modulosEspecificos)
  };
}

/**
 * Obtiene todas las carreras disponibles para una universidad
 */
export function getCarrerasParaUniversidad(universidadId) {
  if (universidadId === 'UNINAV') {
    return CARRERAS_POR_UNIVERSIDAD.UNINAV;
  }
  
  // Para otras universidades, devolver catálogo genérico filtrado
  // En producción, cada universidad tendría su propia lista
  return CATALOGO_CARRERAS_GENERICO;
}

/**
 * Busca universidades por nombre o abreviatura
 */
export function buscarUniversidades(query) {
  const q = query.toLowerCase().trim();
  if (!q) return UNIVERSIDADES_EXANI;
  
  return UNIVERSIDADES_EXANI.filter(u => 
    u.nombre.toLowerCase().includes(q) ||
    u.abreviatura.toLowerCase().includes(q) ||
    u.id.toLowerCase().includes(q) ||
    u.estado.toLowerCase().includes(q)
  );
}

/**
 * Busca carreras por nombre o categoría
 */
export function buscarCarreras(query, universidadId = null) {
  const q = query.toLowerCase().trim();
  const carreras = universidadId ? getCarrerasParaUniversidad(universidadId) : CATALOGO_CARRERAS_GENERICO;
  
  if (!q) return carreras;
  
  return carreras.filter(c => 
    c.nombre.toLowerCase().includes(q) ||
    c.id.toLowerCase().includes(q) ||
    c.categoria?.toLowerCase().includes(q)
  );
}

/**
 * Valida que la combinación universidad-carrera sea válida
 */
export function validarSeleccion(universidadId, carreraId) {
  const uni = UNIVERSIDADES_EXANI.find(u => u.id === universidadId);
  if (!uni) return { valido: false, error: 'Universidad no encontrada' };
  
  const carreras = getCarrerasParaUniversidad(universidadId);
  const carrera = carreras.find(c => c.id === carreraId);
  if (!carrera) return { valido: false, error: 'Carrera no disponible en esta universidad' };
  
  return { valido: true, carrera, universidad: uni };
}

export default {
  UNIVERSIDADES_EXANI,
  MODULOS_CENEVAL,
  AREAS_TRANSVERSALES,
  CARRERAS_POR_UNIVERSIDAD,
  CATALOGO_CARRERAS_GENERICO,
  MODULO_A_TEMA_IDS,
  getModulosParaCarrera,
  getCarrerasParaUniversidad,
  getPlanEstudiosCompleto,
  getTemaIdsParaModulos,
  buscarUniversidades,
  buscarCarreras,
  validarSeleccion
};